import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-white">
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
          <span className="text-[12rem] font-heading font-black text-foreground-800 opacity-20 whitespace-nowrap">
            51CG
          </span>
        </div>
        <div className="relative max-w-7xl mx-auto px-4 md:px-6 py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-6">
                <span className="text-2xl font-heading font-bold">51吃瓜</span>
                <span className="text-xs px-2 py-0.5 rounded-full bg-primary-500 text-white font-label">每日大赛</span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed mb-6">
                汇集全网热门吃瓜爆料与黑料视频<br />
                打造每日吃瓜第一站
              </p>
            </div>

            <div>
              <h4 className="text-sm font-label font-semibold mb-5 text-white">快速导航</h4>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors">首页</Link>
                <Link to="/category/shishi-baoliao" className="text-sm text-foreground-400 hover:text-white transition-colors">热门爆料</Link>
                <Link to="/category/heiliao-baoguang" className="text-sm text-foreground-400 hover:text-white transition-colors">黑料专区</Link>
                <Link to="/category/mingxing-fanche" className="text-sm text-foreground-400 hover:text-white transition-colors">明星翻车</Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-label font-semibold mb-5 text-white">分类浏览</h4>
              <div className="flex flex-col gap-3">
                <Link to="/category/wanghong-tafang" className="text-sm text-foreground-400 hover:text-white transition-colors">网红塌房</Link>
                <Link to="/category/qiye-neimu" className="text-sm text-foreground-400 hover:text-white transition-colors">企业内幕</Link>
                <Link to="/category/mingxing-fanche" className="text-sm text-foreground-400 hover:text-white transition-colors">明星翻车</Link>
                <Link to="/category/shishi-baoliao" className="text-sm text-foreground-400 hover:text-white transition-colors">实时爆料</Link>
                <Link to="/category/heiliao-baoguang" className="text-sm text-foreground-400 hover:text-white transition-colors">黑料曝光</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-label font-semibold mb-5 text-white">关注我们</h4>
              <div className="flex flex-col gap-3 mb-6">
                <a href="#" className="flex items-center gap-3 text-sm text-foreground-400 hover:text-white transition-colors" rel="nofollow">
                  <i className="ri-weibo-line text-lg"></i> 新浪微博
                </a>
                <a href="#" className="flex items-center gap-3 text-sm text-foreground-400 hover:text-white transition-colors" rel="nofollow">
                  <i className="ri-wechat-line text-lg"></i> 微信公众号
                </a>
                <a href="#" className="flex items-center gap-3 text-sm text-foreground-400 hover:text-white transition-colors" rel="nofollow">
                  <i className="ri-bilibili-line text-lg"></i> B站频道
                </a>
              </div>
              <p className="text-xs text-foreground-500 leading-relaxed">
                联系邮箱：admin@51chigua.com<br />
                商务合作：hezuo@51chigua.com
              </p>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 51吃瓜每日大赛 版权所有 | 本站内容仅供娱乐参考
            </p>
            <div className="flex items-center gap-6 text-xs text-foreground-500">
              <a href="#" className="hover:text-white transition-colors">隐私政策</a>
              <a href="#" className="hover:text-white transition-colors">用户协议</a>
              <a href="#" className="hover:text-white transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}